import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "https://maraton.klubmalydunaj.sk";

const socket = io(SOCKET_URL, {
    reconnection: true, // Enable automatic reconnection
    reconnectionAttempts: Infinity, // Retry infinitely
    reconnectionDelay: 1000, // Wait 1 second between retries
    reconnectionDelayMax: 5000, // Maximum delay between retries
    transports: ["websocket", "polling"], // Ensure compatibility with different transport methods
});

export const connectSocket = () => {
    if (!socket.connected) {
        console.log("Connecting to socket...");
        socket.connect(); // Ensure the socket connects
    }
};

export const disconnectSocket = () => {
    if (socket.connected) {
        console.log("Disconnecting from socket...");
        socket.disconnect(); // Disconnect the socket
    }
};

socket.on("connect", () => {
    console.log("✅ Connected to socket server");
});

socket.on("disconnect", () => {
    console.log("❌ Disconnected from socket server");
});

socket.on("connect_error", (err) => {
    console.error("❌ Socket connection error:", err.message);
});

export default socket;
